export const convertUrlToYoutubeEmbed = (url) => {
  const slug = url.split("/")
  return `https://www.youtube.com/embed/${slug[slug.length - 1]}`
}

export const convertToYoutubeEmbed = (url) => {
  const slug = url.split("=")
  return `https://www.youtube.com/embed/${slug[slug.length - 1]}?autoplay=1`
}